<div class="search-bar" [formGroup]="filters">
    <mat-form-field appearance="outline" style="max-width: 120px;" *ngIf="filterNeeded('calendar_year')">
        <mat-label>Year</mat-label>
        <mat-select formControlName="calendar_year">
            <mat-option [value]="null">--</mat-option>
            @for (year of yearsArray; track year) {
            <mat-option [value]="year">{{year}}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" style="max-width: 120px;" *ngIf="filterNeeded('fiscal_year')">
        <mat-label>Year</mat-label>
        <mat-select formControlName="fiscal_year">
            <mat-option [value]="null">--</mat-option>
            @for (year of yearsArray; track year) {
            <mat-option [value]="year">{{year}}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" style="max-width: 120px;" *ngIf="filterNeeded('region')">
        <mat-label>Region</mat-label>
        <mat-select formControlName="region" (selectionChange)="regionChanged()">
            <mat-option [value]="null">--</mat-option>
            @for (region of regions; track region) {
            <mat-option [value]="region">{{region}}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" style="max-width: 300px;" *ngIf="filterNeeded('forest_name')">
        <mat-label>Forest</mat-label>
        <input #forest matInput formControlName="forest_name" [matAutocomplete]="auto" (input)="filter()"
            (focus)="clearForest()" aria-label="Forest Name">
        <mat-icon matSuffix>arrow_drop_down</mat-icon>
        <mat-autocomplete requireSelection #auto="matAutocomplete" (optionSelected)="forestSelected()">
            @for (name of filtered_forest_names | async; track name) {
            <mat-option [value]="name">{{name | forest_filter}}</mat-option>
            }
        </mat-autocomplete>
    </mat-form-field>
    <mat-form-field appearance="outline" style="max-width: 220px;" *ngIf="filterNeeded('baer_name')">
        <mat-label>Fire/Complex Name</mat-label>
        <input matInput formControlName="baer_name" aria-label="Fire/Complex Name">
    </mat-form-field>
    <mat-form-field appearance="outline" style="max-width: 220px;" *ngIf="filterNeeded('assessment_status')">
        <mat-label>Assessment Status</mat-label>
        <mat-select formControlName="assessment_status">
            <mat-option [value]="null">--</mat-option>
            @for (status of statuses; track status) {
            <mat-option [value]="status.text">{{status.text}}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" style="max-width: 220px;" *ngIf="filterNeeded('IRWIN_unique_fire_identifier')">
        <mat-label>Fire Number</mat-label>
        <input matInput formControlName="IRWIN_unique_fire_identifier" aria-label="fire number">
    </mat-form-field>
    <mat-form-field appearance="outline" style="max-width: 220px;" *ngIf="filterNeeded('job_code')">
        <mat-label>Fire Incident Job Code</mat-label>
        <input matInput formControlName="job_code" aria-label="Fire Incident Job Code">
    </mat-form-field>
    <mat-form-field appearance="outline" style="max-width: 170px;" *ngIf="filterNeeded('source')">
        <mat-label>Source</mat-label>
        <mat-select formControlName="source">
            <mat-option [value]="null">--</mat-option>
            <mat-option [value]="'GIS'">GIS</mat-option>
            <mat-option [value]="'NEW'">NEW</mat-option>
            <mat-option [value]="'MERGE'">MERGE</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" style="max-width: 170px;" *ngIf="filterNeeded('fire_complexity')">
        <mat-label>Complexity</mat-label>
        <mat-select formControlName="fire_complexity">
            <mat-option [value]="null">--</mat-option>
            @for (complexity of complexities; track complexity) {
            <mat-option [value]="complexity.text">{{complexity.text}}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" style="max-width: 170px;" *ngIf="filterNeeded('team_lead')">
        <mat-label>Team Lead</mat-label>
        <mat-select formControlName="team_lead">
            <mat-option [value]="null">--</mat-option>
            @for (team_lead of team_leads; track team_lead) {
            <mat-option [value]="(team_lead.first_name+' '+team_lead.last_name)">{{team_lead.first_name}} {{team_lead.last_name}}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" style="max-width: 220px;" *ngIf="filterNeeded('IRWIN_POO_state')">
        <mat-label>State of Fire Origin</mat-label>
        <mat-select formControlName="IRWIN_POO_state">
            <mat-option [value]="null">--</mat-option>
            @for (state of states; track state) {
            <mat-option [value]="state">{{state}}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" style="max-width: 220px;" *ngIf="filterNeeded('team_needs')">
        <mat-label>Team Needs</mat-label>
        <mat-select formControlName="team_needs">
            <mat-option [value]="null">--</mat-option>
            <mat-option [value]="'Needed'">Needed</mat-option>
            <mat-option [value]="'Covered Locally'">Covered Locally</mat-option>
            <mat-option [value]="'Covered Regionally'">Covered Regionally</mat-option>
        </mat-select>
    </mat-form-field>
    
    <mat-form-field appearance="outline" style="max-width: 220px;" *ngIf="filterNeeded('report_baer_name')">
        <mat-label>Report Name</mat-label>
        <input matInput formControlName="report_baer_name" aria-label="Report Name">
    </mat-form-field>
    <mat-form-field appearance="outline" style="max-width: 220px;" *ngIf="filterNeeded('report_status')">
        <mat-label>Report Status</mat-label>
        <mat-select formControlName="report_status">
            <mat-option [value]="null">--</mat-option>
            @for (status of reportStatuses; track status) {
            <mat-option [value]="status.report_status">{{status.report_status}}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" style="max-width: 220px;" *ngIf="filterNeeded('report_id')">
        <mat-label>Report ID</mat-label>
        <input matInput formControlName="report_id" aria-label="Report ID">
    </mat-form-field>
    <mat-form-field appearance="outline" style="max-width: 320px;" *ngIf="filterNeeded('report_type')">
        <mat-label>Report Type</mat-label>
        <mat-select formControlName="report_type">
            <mat-option [value]="null">--</mat-option>
            <mat-option [value]="'Pre-assessment Request'">Pre-assessment Request</mat-option>
            <mat-option [value]="'Emergency Stabilization'">Emergency Stabilization</mat-option>
            <mat-option [value]="'No Treatment'">No Treatment</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" style="max-width: 220px;" *ngIf="filterNeeded('action_type')">
        <mat-label>Action Type</mat-label>
        <mat-select formControlName="action_type">
            <mat-option [value]="null">--</mat-option>
            <mat-option [value]="'Pre-Assessment'">Pre-Assessment</mat-option>
            <mat-option [value]="'Initial'">Initial</mat-option>
            <mat-option [value]="'Interim'">Interim</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" style="max-width: 220px;" *ngIf="filterNeeded('name')">
        <mat-label>User Name</mat-label>
        <input matInput formControlName="name" aria-label="Users Name">
    </mat-form-field>
    <mat-form-field appearance="outline" style="max-width: 220px;" *ngIf="filterNeeded('agency')">
        <mat-label>Agency</mat-label>
        <mat-select formControlName="agency">
            <mat-option [value]="null">--</mat-option>
            <mat-option [value]="'Forest Office'">Forest Office</mat-option>
            <mat-option [value]="'Regional Office'">Regional Office</mat-option>
            <mat-option [value]="'Washington Office'">Washington Office</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" style="max-width: 200px;" *ngIf="filterNeeded('skills_list')">
        <mat-label>BAER Skills</mat-label>
        <mat-select formControlName="skills_list">
            <mat-option [value]="null">--</mat-option>
            @for (skill of skills; track skill) {
            <mat-option [value]="skill.text" *ngIf="skill.value < 20">{{skill.text}}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" style="max-width: 300px;" *ngIf="filterNeeded('skills_list_read')">
        <mat-label>READ Skills</mat-label>
        <mat-select formControlName="skills_list_read">
            <mat-option [value]="null">--</mat-option>
            @for (skill of skills; track skill) {
            <mat-option [value]="skill.text" *ngIf="skill.value >= 20">{{skill.text}}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" style="max-width: 300px;" *ngIf="filterNeeded('bear_role')">
        <mat-label>Positions</mat-label>
        <mat-select formControlName="bear_role">
            <mat-option [value]="null">--</mat-option>
            @for (role of roles; track role) {
            <mat-option [value]="role.text">{{role.text}}</mat-option>
            }
        </mat-select>
    </mat-form-field>
</div>

<div class="filter-btns" *ngIf="selectedColumns?.length > 0">
    <button aria-label="run" class="usa-button" (click)="runReport()">Run Report</button>
    <button aria-label="clear" class="usa-button usa-button--secondary" (click)="clearFilters()">Clear
        Filters</button>
</div>